// Cap voice notes at 5 minutes to keep transcription requests bounded.
export const MAX_RECORDING_DURATION_MS = 5 * 60 * 1000;
export const FALLBACK_RECORDING_MIME_TYPE = "audio/webm";
